export const PARENT_SLICE_NAME = 'scheduleBuilderSchedule' as const;
export const SLICE_NAME = 'roles' as const;

export const RELATIONSHIP_TYPES = {
  JOB: 'job',
  JOB_POSITION: 'job_position',
  SHIFT: 'shift',
} as const;

export const ROLE_COLORS = {
  RED: '#FF0000',
  BLUE: '#0000FF',
  GREEN: '#00FF00',
  YELLOW: '#FFFF00',
  PURPLE: '#800080',
  ORANGE: '#FFA500',
} as const;
